import { context } from "@core-ts/Contexts/Context"
import { CacheBase } from "./CacheBase"

type SessionInstanceCacheKey = {
    userKey: string
    instance: string
    sessionToken: string
}

// All entries in this cache is global over a specific session (and implicitly instance)
// This is likely the cache you want to use to cache session data per user that is expensive to calculate
export class SessionInstanceCache<V, StateType = string> extends CacheBase<SessionInstanceCacheKey, V, StateType> {
    constructor(name: string, timeoutSeconds: number | null = null, maximumCacheSize: number | null = null) {
        super("SessionInstanceCache." + name, timeoutSeconds, maximumCacheSize)
    }
    async get(userKey: string, fn: () => Promise<V>, stateWhenValid: StateType | null = null): Promise<V> {
        const key = {
            userKey: userKey,
            instance: context.instance.instanceName,
            // Frontend is by default just a single session so we can use a constant session token
            sessionToken: context.application.isFrontend ? "frontend" : context.unverifiedSession.sessionToken
        }

        return this.internalGet(key, fn, stateWhenValid)
    }
}
